import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import { useApiClientDocument } from '~/@api/client/useApiClientDocument'
import type {
  IDocumentListOkResponse,
  IDocumentListRequest,
} from '~/@api/generated-api-types-document/Api'
import type { DocumentTypeId } from '../types'
import {
  defaultPaginationParams,
  infiniteQueryNextPageParam,
} from '~/@mid_query/utils/pagination.utils'

type Props = {
  typeIds: Array<DocumentTypeId>
  filterId: number
}

// Documents list presunutý z Meteor `user/account/portfolio/documents` na Nest
// `POST /document` (`/document` doc, apiClientDocument). Body aj response shape nezmenené,
// len `status` pole vystriedalo `message`.
export function useDocumentsQuery({ typeIds, filterId }: Props) {
  const client = useApiClientDocument()

  async function fetchDocuments(args: IDocumentListRequest) {
    return client.document
      .appFilesControllerGetDocuments(args, {
        secure: true,
      })
      .then((resp) => resp.data)
  }

  return useInfiniteQuery({
    queryKey: ['documents', filterId],
    queryFn: ({ pageParam = 0 }) =>
      fetchDocuments({
        filter: {
          typeIds,
        },
        ...defaultPaginationParams(pageParam),
      }),
    getNextPageParam: infiniteQueryNextPageParam<IDocumentListOkResponse>,
    initialPageParam: 0,
    // throwOnError: true,
    placeholderData: keepPreviousData,
  })
}
